import { RootState } from 'store/store';

export const selectEmployeeAvailabilityRequestStatus = (state: RootState) =>
  state.projects.employeeAvailabilityRequestStatus;
export const selectEmployeeAvailabilitySelectOptions = (state: RootState) =>
  state.projects.employeeAvailabilitySelectOptions;
